<template>

<app-content :loading="is.loading">

	<app-content-body 
        v-if="!is.loading" 
        :is-call="true"
    >

		<app-content-call 
            theme="blue" 
            icon="application.retract" 
            :title="title" 
            :text="text" 
            button="Confirm" 
            :loading="is.confirming" 
            :has-cancel="true" 
            v-on:click="onConfirmClick" 
            v-on:cancel="onCancelClick"
       />

	</app-content-body>

</app-content>

</template>

<script>

import Vue from 'vue'

export default {

	data: function() {

		return {
			is: {
				loading: true,
				confirming: false
			},
			application: {}
		}

	},

	created: function() {

		this.load();

	},

    computed: {
    
        title: function() {
        
            return (this.application.status === this.$constants.registration.application.status.accepted) ? 'Retract Acceptance' : 'Retract Rejection'
        
        },

        text: function() {
        
            var word = (this.application.status === this.$constants.registration.application.status.accepted) ? 'approved' : 'rejected'

            return 'Move this application back to pending status and any previously ' + word + ' game submissions will also be reset to pending.'
        
        }
    
    },

	methods: {

		onCancelClick: function() {

			this.$router.push({
				name: 'Convention.Registration.Applications.Edit'
			})

		},

		onConfirmClick: async function() {

			this.is.confirming = true

			this.$api.post('convention/registration/application/' + this.$route.params.id + '/retract', this.model).then(function() {
            
                this.$notify({
					message: 'The application status has been retracted.'
				})

				this.$router.push({
                    name: 'Convention.Registration.Applications.Edit'
				})

            }.bind(this))

		},

		load: function() {

			this.$api.get('convention/registration/application/' + this.$route.params.id + '/retract').then(function(response) {

				Vue.set(this, 'application', response.application)

				this.is.loading = false

			}.bind(this), function() {
            
                this.$notify({
					message: 'This is not an accepted or rejected application.',
					type: 'error'
				})

				this.$router.push({
                    name: 'Convention.Registration.Applications.Edit'
				})
            
            }.bind(this))

		}

	}

}

</script>

<style scoped>

.form {
    display: flex;
    flex-direction: column;
    margin-top: 40px;
    width: 100%;
}

.form >>> .input {
    width: 100%;
}

</style>
